export default __webpack_public_path__ + "static/media/gas-station-color.b9b55691.svg";